export default __webpack_public_path__ + "static/media/pharox-menu-logo-login.29e9dbf9.svg";